//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { postAction } from '@/api/manage';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
var qualityColumns = [{
  title: '检测项目',
  dataIndex: 'title',
  align: 'center',
  width: '25%',
  scopedSlots: {
    customRender: 'title'
  }
}, {
  title: '设置标准溶液浓度',
  dataIndex: 'standardConcentration',
  align: 'center',
  width: '25%',
  scopedSlots: {
    customRender: 'standardConcentration'
  }
}, {
  title: '证书编号',
  align: 'center',
  dataIndex: 'certificateNum',
  width: '25%',
  scopedSlots: {
    customRender: 'certificateNum'
  }
}, {
  title: '标准值',
  align: 'center',
  dataIndex: 'standardValue',
  width: '25%',
  scopedSlots: {
    customRender: 'standardValue'
  }
}];
var historyColumns = [{
  title: '检测项目',
  width: '200px',
  dataIndex: 'monitorProject_dictText',
  align: 'center',
  scopedSlots: {
    customRender: 'monitorProject_dictText'
  }
}, {
  title: '设置标准溶液浓度',
  dataIndex: 'standardConcentration',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'standardConcentration'
  }
}, {
  title: '证书编号',
  width: '200px',
  align: 'center',
  dataIndex: 'certificateNum',
  scopedSlots: {
    customRender: 'certificateNum'
  }
}, {
  title: '标准值',
  width: '200px',
  align: 'center',
  dataIndex: 'standardValue',
  scopedSlots: {
    customRender: 'standardValue'
  }
}, {
  title: '提交时间',
  width: '200px',
  align: 'center',
  dataIndex: 'commitTime',
  scopedSlots: {
    customRender: 'commitTime'
  }
}, {
  title: '提交人',
  width: '200px',
  align: 'center',
  dataIndex: 'userId_userName',
  scopedSlots: {
    customRender: 'userId_userName'
  }
} // {
//   title: '审核时间',
//   align: 'center',
//   dataIndex: 'reviewedTime',
//   scopedSlots: { customRender: 'reviewedTime' },
// },
// {
//   title: '审核人',
//   align: 'center',
//   dataIndex: 'reviewedBy',
//   scopedSlots: { customRender: 'reviewedBy' },
// },
// {
//   title: '是否过期',
//   align: 'center',
//   dataIndex: 'status',
//   scopedSlots: { customRender: 'status' },
// },
];
export default {
  name: "WeekQualityControlModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "操作",
      visible: false,
      addOrHistory: false,
      disableSubmit: '',
      historyColumns: historyColumns,
      qualityColumns: qualityColumns,
      historyData: [],
      qualityData: [],
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: "/om/week/quality/control"
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add(factorModelList) {
      this.edit({
        factorModelList: factorModelList
      });
    },
    edit: function edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.factorModelList) {
        this.qualityData = this.model.factorModelList;
      } else {
        this.historyData = this.model.historyData;
      }
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk(data) {
      var that = this;
      that.confirmLoading = true;
      that.qualityData = [];
      data.filter(function (saveData) {
        if (!(saveData.standardConcentration == '' && saveData.certificateNum == '' && saveData.standardValue == '')) {
          that.qualityData.push(saveData);
        }
      });
      postAction(this.url.add, that.qualityData).then(function (res) {
        if (res.success) {
          that.$message.success(res.message);
          that.$emit('ok');
          that.close();
        } else {
          that.$message.warning(res.message);
        }
      }).finally(function () {
        that.confirmLoading = false;
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};